import './Fieldsubmit.scss'

import React from 'react'
import {style} from '../../util/style'

const styles = style('fieldsubmit', ['row', 'field', 'submit'])

export type FieldsubmitType = {
	type?: 'text' | 'email' | 'search'
	name: string
	id?: string
	label?: string
	submit?: string
}

export const FieldsubmitRow = ({children}) => (
	<div className={styles.row()}>{children}</div>
)

export const FieldsubmitField = ({children}) => (
	<div className={styles.field()}>{children}</div>
)

export const FieldsubmitSubmit = ({
	maxwidth = false,
	nomargin = false,
	children
}) => (
	<div className={styles.submit().mod({maxwidth}).mod({nomargin})}>
		{children}
	</div>
)
